import React from "react";

import { Button } from "clearsense-ui/components";

const ExpandAllCollapseAll = ({ onExpand, onCollapse }) => (
  <>
    <Button
      style="text"
      label="Expand All"
      size="small"
      className="text-xs text-primary-shade underline"
      onClick={onExpand}
    />
    {"|"}
    <Button
      style="text"
      label="Collapse All"
      size="small"
      className="text-xs text-primary-shade underline"
      onClick={onCollapse}
    />
  </>
);

export default ExpandAllCollapseAll;
